<template>
  <span>
    <v-btn v-if="tipoBtn == 1" color="info" small @click="GetPdf()" :loading="cargandoDatos" :disabled="!id">
      <v-icon left small>
        {{ icons.mdiFilePdfBox }}
      </v-icon>
      PDF
    </v-btn>

    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on, attrs }">
        <a class="pr-1" v-bind="attrs" v-on="on" @click="GetPdf()">
          <v-icon color="primary">{{ icons.mdiFilePdfBox }}</v-icon>
        </a>
      </template>
      <span>PDF</span>
    </v-tooltip>
    <Pdf ref="pdfRef"></Pdf>
  </span>
</template>
<script>
import AjusteServices from '@/api/servicios/inventario/AjusteServices'
import { mdiFilePdfBox } from '@mdi/js'
import { ref } from '@vue/composition-api'
import FuncionesGenerales from '@/funciones/funciones'
import Pdf from '@/components/Pdf.vue'
export default {
  props: {
    id: Number,
    tipoBtn: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Pdf,
  },
  setup(props) {
    const cargandoDatos = ref(false)
    const pdfRef = ref(null)
    const GetPdf = () => {
      cargandoDatos.value = true

      AjusteServices.ajusteListarPaginado({ id: props.id })
        .then(response => {
          console.log(response)
          if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
            const datoInit = response.data.datos.datos[0]
            const cuerpoTablaDetalles = []

            datoInit.productos.forEach(item => {
              cuerpoTablaDetalles.push([
                { content: item.producto.id, styles: { halign: 'left' } },
                { content: item.producto.nombre, styles: { halign: 'left' } },
                { content: item.producto.unidad_medida.descripcion, styles: { halign: 'left' } },
                { content: '$' + FuncionesGenerales.formatoNumeric(item.costo), styles: { halign: 'right' } },
                { content: FuncionesGenerales.formatoNumeric(item.cantidad), styles: { halign: 'right' } },
              ])
            })

            const datosInit = {
              nombreDocumento: `Ajuste: ${datoInit.numero_documento}`,

              cabecera1: {
                visible: true,
              },
              titulo: {
                visible: true,
                posicion: 'center',
                texto: 'Ajuste',
                TamanoLetras: 14,
                color: '#7B7B7B',
              },
              cabecera2: {
                visible: true,
                datos: [
                  { texto: '# ' + datoInit.numero_documento, TamanoLetras: 14, color: '#FF0000' },
                  { texto: 'Fecha Creacion: ' + FuncionesGenerales.formatoFecha(datoInit.fecha, 1) },
                  {
                    texto:
                      'Hora Creacion: ' +
                      FuncionesGenerales.formatoFecha(datoInit.fecha, 2)
                        .replace(/\u00a0/g, '')
                        .replace(/\u202f/g, ''),
                  },
                  { texto: 'Empleado: ' + datoInit.empleado_json.nombre + ' ' + datoInit.empleado_json.apellido },
                ],
              },
              sub1: {
                visible: true,
                datos: [
                  { texto: 'Fecha Ajuste: ' + FuncionesGenerales.formatoFecha(datoInit.fecha_ajuste, 1) },
                  { texto: 'Puesto: ' + datoInit.puesto_json.nombre },
                  { texto: 'Almacen: ' + datoInit.almacen_json.descripcion },
                ],
              },
              sub2: {
                visible: true,
                datos: [
                  { texto: 'Estado:' + datoInit.estado_json.descripcion },
                  { texto: 'Descripcion:' },
                  { texto: datoInit.descripcion },
                ],
              },

              cuerpo1: {
                visible: true,
                datos: [
                  {
                    titulo: { texto: 'Detalles', TamanoLetras: 12 },
                    columnStyles: {
                      3: {
                        halign: 'right',
                      },
                    },
                    tablas: {},
                    head: [
                      [
                        { content: 'id', styles: { halign: 'left' } },
                        { content: 'Producto', styles: { halign: 'left' } },
                        { content: 'Medida', styles: { halign: 'left' } },
                        { content: 'Costo', styles: { halign: 'right' } },
                        { content: 'Cantidad', styles: { halign: 'right' } },
                      ],
                    ],
                    body: cuerpoTablaDetalles,
                  },
                ],
              },
            }

            pdfRef.value.generarPDF(datosInit)
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          cargandoDatos.value = false
        })
    }

    return {
      GetPdf,
      cargandoDatos,
      pdfRef,
      icons: {
        mdiFilePdfBox,
      },
    }
  },
}
</script>